import { isElement } from 'lodash';
import ViewportDetect from '@djforth/viewport-detection-fp';

const vpDetect = ViewportDetect();

class ResponsiveTableClass {
  // Get the heights of the scrollable table rows
  _getHeights = scrollable => {
    const trScrollable = [...scrollable.getElementsByTagName('tr')];

    const heights = trScrollable.map(tr => tr.offsetHeight);

    return heights;
  };

  // Add a "first" class to the first children of each row
  _markFirstChildren = table => {
    const tableRows = [...table.getElementsByTagName('tr')];

    tableRows.forEach(tableRow => {
      tableRow.children[0].className = 'first-element';
    });
  };

  // Remove the original table from the DOM
  _removeOriginalTable = table => {
    table.parentNode.removeChild(table);
  };

  removeWidthsAndHeights = table => {
    table.removeAttribute('width');
    table.removeAttribute('height');

    const elms = [...table.querySelectorAll('tr, td')];

    elms.forEach(elm => {
      elm.removeAttribute('width');
      elm.removeAttribute('height');
    });

    return table;
  };

  // Set the heights of the pinned table rows
  _setHeights = (pinned, heights) => {
    const trPinned = [...pinned.getElementsByTagName('tr')];

    trPinned.forEach((tr, i) => {
      tr.style.height = `${heights[i]}px`;
    });
  };

  constructor(container) {
    this.container = container.querySelector('.tinymce');
    // Really nasty - I need to re-factor this module. IH 01/04/16
    if (this.container === null) {
      this.container = container.querySelector('.table-container');
    }
    this.switched = false;
    this.table = this.container.querySelector('table');

    if (isElement(this.container) && isElement(this.table)) {
      this._updateTables(window.innerWidth);

      vpDetect.addCallback((d, w) => {
        this._updateTables.call(this, w);
      });

      vpDetect.track();
    }
  }

  // Create a tables wrapper div for both tables
  _createAndPopulateTablesWrapper(pinned, scrollable) {
    const tablesWrapper = document.createElement('div');

    tablesWrapper.setAttribute('class', 'table-wrapper');

    // Append the new tables into the tables wrapper
    tablesWrapper.appendChild(pinned);
    tablesWrapper.appendChild(scrollable);

    // Append the tables wrapper to the container
    this.container.appendChild(tablesWrapper);

    return tablesWrapper;
  }

  // Process the table row heights
  _processHeights(pinned, scrollable) {
    const heights = this._getHeights(scrollable);

    this._setHeights(pinned, heights);
  }

  // Create a wrapper div for each table
  _processTable(table, divclass) {
    const newTable = document.createElement('div');

    newTable.setAttribute('class', divclass);
    newTable.innerHTML = table.outerHTML;

    this._markFirstChildren(newTable);

    return newTable;
  }

  // Split the original table into two separate tables
  _splitTable(table) {
    // Remove the original table from the DOM
    this._removeOriginalTable(table);

    // Process the pinned table
    this.pinned = this._processTable(this.removeWidthsAndHeights(table), 'pinned');

    // Process the scrollable table
    this.scrollable = this._processTable(table, 'scrollable');

    // Create a tables wrapper div for both tables
    this.tablesWrapper = this._createAndPopulateTablesWrapper(this.pinned, this.scrollable);

    // Set the heights of the pinned table based on the scrollable table
    this._processHeights(this.pinned, this.scrollable);
  }

  _unsplitTable(table) {
    // Remove the pinned table from the DOM
    this.pinned.parentNode.removeChild(this.pinned);

    // Remove the tables wrapper from the DOM
    this.tablesWrapper.parentNode.removeChild(this.tablesWrapper);

    // Append the original table to the container
    this.container.appendChild(table);
  }

  _updateTables(width) {
    if (width <= 768 && !this.switched) {
      this.switched = true;
      this._splitTable(this.table);
    } else if (width > 768 && this.switched) {
      this.switched = false;
      this._unsplitTable(this.table);
    }
  }
}

export default ResponsiveTableClass;
